// /c:/Users/faizan.pathan/scraptrade/src/features/buyer/buyeService.js

import { BuyerAPI, UserAPI } from "../../services/apiService";

export const getProfile = async () => {
  const response = await UserAPI.viewProfile();
  return response.data;
};

export const updateProfile = async (data) => {
  // Validate name first
  if (!data.name?.trim()) {
    throw new Error("Name is required");
  }

  const formData = new FormData();

  formData.append("name", data.name.trim());

  if (data.phone?.trim()) formData.append("phone", data.phone.trim());
  if (data.company_name?.trim())
    formData.append("company_name", data.company_name.trim());
  if (data.trade_preferences?.trim())
    formData.append("trade_preferences", data.trade_preferences.trim());

  if (data.profile_image instanceof File) {
    formData.append("profile_image", data.profile_image);
  }

  const response = await UserAPI.updateProfile(formData);
  return response.data;
};

export const getAddressList = async (data) => {
  const response = await UserAPI.addressList(data);
  return response.data;
};

export const updateAddress = async (data) => {
  const response = await UserAPI.updateAddress(data);
  return response.data;
};

export const changePassword = async (data) => {
  const response = await UserAPI.changePassword(data);
  return response.data;
};

export const uploadKyc = async (formData) => {
  const response = await UserAPI.kycUpload(formData);
  return response.data;
};

export const getKycList = async () => {
  const response = await UserAPI.kycList();
  return response.data.data.documents;
};

export const getAllProducts = async () => {
  const response = await BuyerAPI.getAllProducts();
  return response.data;
};

export const getProductDetail = async (productId) => {
  const response = await BuyerAPI.getProductDetail(productId);
  return response.data.data;
};

export const filterProducts = async (params) => {
  const response = await BuyerAPI.filterProducts(params);
  return response.data;
};

export const getSubcategories = async (categoryId) => {
  const response = await BuyerAPI.getSubcategories(categoryId);
  return response.data?.data || [];
};

export const getBidList = async () => {
  const response = await BuyerAPI.getMyBids();
  return response.data;
};

export const placeBid = async (params) => {
  const response = await BuyerAPI.placeBid(params);
  return response.data;
};

export const acceptBid = async (id) => {
  const response = await BuyerAPI.acceptBid(id);
  return response.data;
};

export const rejectBid = async (id, params) => {
  const response = await BuyerAPI.rejectBid(id, params);
  return response.data;
};

export const getBuyerDashboard = async () => {
  const response = await BuyerAPI.getDashboard();
  return response.data;
};

export const myOrders = async () => {
  const response = await BuyerAPI.myOrders();
  return response.data;
};

export const orderDetails = async (id) => {
  const response = await BuyerAPI.orderDetails(id);
  return response.data;
};

export const orderCancel = async (id) => {
  const response = await BuyerAPI.orderCancel(id);
  return response.data;
};

export const orderTrack = async (id) => {
  const response = await BuyerAPI.orderTrack(id);
  return response.data;
};

export const orderPlace = async (data) => {
  const response = await BuyerAPI.orderPlace(data);
  return response.data;
};

export const orderSummary = async (id) => {
  const response = await BuyerAPI.orderSummary(id);
  return response.data;
};

export const generateInvoice = async (data) => {
  const response = await BuyerAPI.invoice(data);
  return response.data; // returns blob directly
};

export const createTpiRequest = async (id) => {
  const response = await BuyerAPI.requestTpi(id)
  return response.data
}

export const paymentMethods = async () => {
  const response = await BuyerAPI.paymentMethods();
  return response.data;
};

export const markComplete = async (id) => {
  const response = await BuyerAPI.markComplete(id);
  return response.data;
};

export const checkOutSession = async (data) => {
  const response = await BuyerAPI.checkOutSession(data);
  return response.data;
};

export const paymentStatus = async (id) => {
  const response = await BuyerAPI.paymentStatus(id);
  return response.data;
};

export const marketData = async () => {
  const response = await BuyerAPI.marketData();
  return response.data;
};

export const randomProducts = async () => {
  const response = await BuyerAPI.randomProducts();
  return response.data;
};

export const reverseBids = async () => {
  const response = await BuyerAPI.reverseBids();
  return response.data;
};

export const reverseBidStore = async (data) => {
  const response = await BuyerAPI.storeRequirement(data);
  return response.data;
};

export const reverseBidDetails = async (id) => {
  const response = await BuyerAPI.reverseBidDetails(id);
  return response.data;
};

export const reverseBidAccept = async (id) => {
  const response = await BuyerAPI.acceptRequirement(id);
  return response.data;
};

export const orderShippingDetails = async (id, data) => {
  const response = await BuyerAPI.orderShippingDetails(id, data);
  return response.data;
};

export const shippingDetails = async (id) => {
  const response = await BuyerAPI.shippingDetails(id);
  return response.data;
};

export const acceptOrder = async (id) => {
  const response = await BuyerAPI.acceptOrder(id);
  return response.data;
};

export const disputeOrder = async (id, data) => {
  const response = await BuyerAPI.disputeOrder(id, data);
  return response.data;
};

export const contactUs = async (data) => {
  const response = await BuyerAPI.contactUs(data);
  return response.data;
};

export const getAllOffers = async () => {
  const response = await BuyerAPI.getAllOffers();
  return response.data;
};

export const getOffersDetail = async (productId) => {
  const response = await BuyerAPI.getOffersDetail(productId);
  // console.log("Seller Product data:", response.data);
  return response.data;
};

export const createOffers = async (data) => {
  const payload = new FormData();

  // // Ensure boolean-like fields are numeric (0 or 1)
  // if (typeof data.is_reverse_auction === "boolean") {
  //   data.is_reverse_auction = data.is_reverse_auction ? 1 : 0;
  // }

  const cleanDescription = (desc) => {
    if (
      typeof desc === "string" &&
      desc.startsWith("<p>") &&
      desc.endsWith("</p>")
    ) {
      return desc.replace(/^<p>|<\/p>$/g, "").trim();
    }
    return desc;
  };

  //  Only the fields currently accepted by backend
  const requiredKeys = [
    "category_id",
    "subcategory_id",
    "name",
    "description",
    // "price",
    "quantity",
    "location",
    "unit_of_measurement",
    "incoterms",
    "payment_terms",
    "lead_time",
    "delivery_port",
    "metal_code",
    "sorting_type",
    "attachment",
    "waste_percentage",
    "waste_range",
    // "toxic_level",
    "hazard_types",
    "hazard_description",
    "price_per_unit",
    // "weight",
    "currency",
    "estimated_price",
    "max_buying_price",
    "discount_percentage",
    // "is_reverse_auction",
    // "minimum_asking_price",
    // "bid_increment",
    // "bid_closed_at",
    // "reverse_close_price",
    // "auction_status",
    // "allow_bidding",
    "save_as_draft",
  ];

  // append only required keys
  requiredKeys.forEach((k) => {
    let value = data[k];
    if (value === undefined || value === null) value = "";

    // Clean description field
    if (k === "description") {
      value = cleanDescription(value);
    }

    // numeric fields
    const numericKeys = [
      "price",
      "quantity",
      "lead_time",
      "weight",
      "price_per_unit",
      "estimated_price",
      "minimum_asking_price",
      "bid_increment",
      "reverse_close_price",
      "max_buying_price",
      "discount_percentage",
    ];
    if (numericKeys.includes(k)) {
      value = value === "" ? "" : Number(value);
    }

    payload.append(k, value);
  });

  // Add hazard_types array properly
  if (Array.isArray(data.hazard_types) && data.hazard_types.length > 0) {
    data.hazard_types.forEach((h, i) => {
      payload.append(`hazard_types[${i}]`, h);
    });
  } else {
    console.log("hazard_types is empty or not an array:", data.hazard_types);
    // If hazard_types is null or empty, append it as an array with a single null element
    payload.append("hazard_types[0]", [null]);
  }

  // Set currency based on data or default to empty for validation to catch if necessary
  payload.append("currency", data.currency || "");

  //  specifications — only append if available
  if (Array.isArray(data.specifications)) {
    data.specifications.forEach((s, i) => {
      if (s.field_id && s.value) {
        payload.append(`specifications[${i}][field_id]`, s.field_id);
        payload.append(`specifications[${i}][value]`, s.value);
      }
    });
  }

  //  faqs — required, even if empty
  if (Array.isArray(data.faqs)) {
    data.faqs.forEach((f, i) => {
      payload.append(`faqs[${i}][question]`, f?.question || "");
      payload.append(`faqs[${i}][answer]`, f?.answer || "");
    });
  } else {
    payload.append(`faqs[0][question]`, "");
    payload.append(`faqs[0][answer]`, "");
  }

  //  Files (required — use placeholder if missing)
  if (data.image) {
    // Check if it's a FileList/array or a direct File object
    const imageFile = data.image[0] || data.image;
    if (imageFile instanceof File) {
      payload.append("image", imageFile);
    } else {
      payload.append("image", ""); // backend requires image field
    }
  } else {
    payload.append("image", ""); // backend requires image field
  }

  if (data.video) {
    const videoFile = data.video[0] || data.video;
    if (videoFile instanceof File) {
      payload.append("video", videoFile);
    } else {
      payload.append("video", ""); // backend requires video field
    }
  } else {
    payload.append("video", ""); // backend requires video field
  }

  // Debug log
  for (let [key, val] of payload.entries()) {
    console.log(`${key}:`, val);
  }
  console.groupEnd();
  console.group("FormData payload", payload);

  const response = await BuyerAPI.addOffer(payload);
  return response.data;
};

export const updateOffers = async (id, data) => {
  const payload = new FormData();

  // Ensure boolean-like fields are numeric (0 or 1)
  // if (typeof data.is_reverse_auction === "boolean") {
  //   data.is_reverse_auction = data.is_reverse_auction ? 1 : 0;
  // }
  // data.allow_bidding = Number(data.allow_bidding);

  const cleanDescription = (desc) => {
    if (
      typeof desc === "string" &&
      desc.startsWith("<p>") &&
      desc.endsWith("</p>")
    ) {
      return desc.replace(/^<p>|<\/p>$/g, "").trim();
    }
    return desc;
  };

  //  Only the fields currently accepted by backend
  const requiredKeys = [
    "category_id",
    "subcategory_id",
    "name",
    "description",
    // "price",
    "quantity",
    "location",
    "unit_of_measurement",
    "incoterms",
    "payment_terms",
    "lead_time",
    "delivery_port",
    "metal_code",
    "sorting_type",
    "attachment",
    "waste_percentage",
    "waste_range",
    "toxic_level",
    "hazard_types",
    "hazard_description",
    "price_per_unit",
    // "weight",
    "currency",
    "estimated_price",
    "max_buying_price",
    "discount_percentage",
    "save_as_draft",

  ];

  requiredKeys.forEach((k) => {
    let value = data[k];
    if (value === undefined || value === null) value = "";

    if (k === "description") {
      value = cleanDescription(value);
    }

    const numericKeys = [
      "price",
      "quantity",
      "lead_time",
      "weight",
      "price_per_unit",
      "estimated_price",
      "minimum_asking_price",
      "bid_increment",
      "reverse_close_price",
      "max_buying_price",
      "discount_percentage",
    ];
    if (numericKeys.includes(k)) {
      value = value === "" ? "" : Number(value);
    }

    payload.append(k, value);
  });

  // Add hazard_types array properly
  if (Array.isArray(data.hazard_types)) {
    data.hazard_types.forEach((h, i) => {
      payload.append(`hazard_types[${i}]`, h);
    });
  }

  // specifications
  if (Array.isArray(data.specifications)) {
    data.specifications.forEach((s, i) => {
      if (s.field_id && s.value) {
        payload.append(`specifications[${i}][field_id]`, s.field_id);
        payload.append(`specifications[${i}][value]`, s.value);
      }
    });
  }

  // faqs
  if (Array.isArray(data.faqs)) {
    data.faqs.forEach((f, i) => {
      payload.append(`faqs[${i}][question]`, f?.question || "");
      payload.append(`faqs[${i}][answer]`, f?.answer || "");
    });
  } else {
    payload.append(`faqs[0][question]`, "");
    payload.append(`faqs[0][answer]`, "");
  }

  // Files - handle both File object and array
  if (data.image) {
    // Check if it's a FileList/array or a direct File object
    const imageFile = data.image[0] || data.image;
    if (imageFile instanceof File) {
      payload.append("image", imageFile);
    }
  }

  if (data.video) {
    const videoFile = data.video[0] || data.video;
    if (videoFile instanceof File) {
      payload.append("video", videoFile);
    }
  }

  // Debug log
  console.group("FormData payload for update");
  for (let [key, val] of payload.entries()) {
    console.log(`${key}:`, val);
  }
  console.groupEnd();

  const response = await BuyerAPI.updateOffers(id, payload);
  return response.data;
};

export const deleteOffers = async (id) => {
  const response = await BuyerAPI.deleteOffers(id);
  return response.data;
};

export const calculatePrice = async (data) => {
  const response = await BuyerAPI.calculatePrice(data);
  return response.data;
};

export const getMetalCode = async (data) => {
  const response = await BuyerAPI.getMetalCode(data);
  return response.data;
};

export const getSpecifications = async (id) => {
  const response = await BuyerAPI.getSpecifications(id);
  return response.data;
};

export const respondCounterOffer = async (id, data) => {
  const response = await BuyerAPI.respondCounterOffer(id, data);
  return response.data;
};

export const getCategories = async () => {
  const response = await BuyerAPI.getCategories();
  return response.data;
};

export const getSubcategoriesById = async (categoryId) => {
  // console.log('category id in buyer service:',categoryId)
  const response = await BuyerAPI.getSubcategories(categoryId);
  return response.data;
};

export const getPendingTransactions = async () => {
  const response = await BuyerAPI.getPendingTransactions();
  return response.data;
};

export const sellerCounterOffers = async (id, data) => {
  const response = await BuyerAPI.sellerCounterOffers(id, data);
  return response.data;
}

export const getTransactionDetails = async (id) => {
  const response = await BuyerAPI.getTransactionDetails(id);
  return response.data;
};

export const generateDescription = async (data) => {
  const response = await BuyerAPI.generateDescription(data);
  return response.data;
};

export const generateFaqs = async (data) => {
  const response = await BuyerAPI.generateFaqs(data);
  return response.data;
};

export const getCountries = async () => {
  const response = await BuyerAPI.getCountries()
  return response.data
}

export const getStates = async (countryId) => {
  const response = await BuyerAPI.getStates(countryId)
  return response.data
}

export const getCities = async (stateId) => {
  const response = await BuyerAPI.getCities(stateId)
  return response.data
}

export const getOutOfRange = async () => {
  const response = await BuyerAPI.getOutOfRangeList()
  return response.data
}

export const adminAssistance = async (id, data) => {
  const response = await BuyerAPI.adminAssistance(id, data)
  return response.data
}

export const acceptCharges = async (id) => {
  const response = await BuyerAPI.acceptCharges(id)
  return response.data
}

export const rejectCharges = async (id) => {
  const response = await BuyerAPI.rejectCharges(id)
  return response.data
}

export const buyerService = {
  getProfile,
  updateProfile,
  getAddressList,
  updateAddress,
  changePassword,
  uploadKyc,
  getKycList,
  getAllProducts,
  getProductDetail,
  filterProducts,
  getSubcategories,
  getBidList,
  placeBid,
  acceptBid,
  rejectBid,
  getBuyerDashboard,
  myOrders,
  orderDetails,
  orderCancel,
  orderTrack,
  orderPlace,
  orderSummary,
  paymentMethods,
  markComplete,
  checkOutSession,
  paymentStatus,
  marketData,
  randomProducts,
  reverseBids,
  reverseBidStore,
  reverseBidDetails,
  reverseBidAccept,
  generateInvoice,
  createTpiRequest,
  orderShippingDetails,
  shippingDetails,
  acceptOrder,
  disputeOrder,
  contactUs,
  getAllOffers,
  getOffersDetail,
  createOffers,
  updateOffers,
  deleteOffers,
  calculatePrice,
  getMetalCode,
  getSpecifications,
  respondCounterOffer,
  getPendingTransactions,
  getTransactionDetails,
  sellerCounterOffers,
  getCategories,
  getSubcategoriesById,
  generateDescription,
  generateFaqs,
  getCountries,
  getStates,
  getCities,
  getOutOfRange,
  adminAssistance,
  acceptCharges,
  rejectCharges
};
